import React, {useState} from 'react';
import {useTranslation} from 'react-i18next';
import {useParams} from 'react-router-dom';
import _isEmpty from 'lodash/isEmpty';
import Strapi from '../../../components/strapi';
import LoadingPage from '../../../components/loadingpage';
import useWindowWidth from '../../../components/hooks/useWindowWidth';
import PrerenderLayout from '../../../components/layout/PrerenderLayout';
import GetStrapiContent from '../../../components/strapi/getstrapicontent';

export default function AccessibilityStatement({location}) {
  const [isLoaded, setIsLoaded] = useState(false);
  const {i18n} = useTranslation();
  const width = useWindowWidth();
  const {productType} = useParams();
  const {strapiContent, functionKey} = GetStrapiContent(
    'COMPANY_ACCESSIBILITY',
    setIsLoaded,
    location,
    true,
    productType
  );
  if (!isLoaded || _isEmpty(strapiContent))
    return (
      <PrerenderLayout>
        <LoadingPage />
      </PrerenderLayout>
    );

  return (
    <PrerenderLayout functionKey={functionKey} enableFullHeight={false}>
      {strapiContent.map((s, i) => (
        <div key={`strapi-sec${i}`}>
          <Strapi
            content={s}
            width={width}
            productPage={'COMPANY_ACCESSIBILITY'}
            i18n={i18n}
          />
        </div>
      ))}
    </PrerenderLayout>
  );
}
